import useFormValidation from "hooks/useFormValidation";
import { Label } from "layout/typography/Label";
import { Chips } from "primereact/chips";
import { useState, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

import { formValidationConstants } from "../helpers/formValidations";

const Title = styled.h3`
  margin-bottom: 16px;
`;

export function BundledCptCodes() {
  const {
    control,
    trigger,
    formState: { errors },
    watch,
  } = useFormContext();
  const [cptCodes, setCptCodes] = useState<string[]>([]);
  const { getFormErrorMessage, handleOnBlurField } = useFormValidation();
  const watchedCptCodes = watch("bundledCptCodes");

  useEffect(() => {
    if (watchedCptCodes) {
      setCptCodes(watchedCptCodes);
    }
  }, [watchedCptCodes]);

  return (
    <div className="block bg-white border-round p-4 mb-4">
      <Title>Bundled CPT Codes</Title>
      <Label htmlFor="bundledCptCodes">Add Bundled CPT Codes</Label>
      <Controller
        name="bundledCptCodes"
        control={control}
        rules={{
          required: formValidationConstants.CPT_CODES.CODES,
        }}
        render={({ field: { onChange, onBlur } }) => (
          <>
            <Chips
              id="bundledCptCodes"
              value={cptCodes}
              className="w-full mt-2"
              placeholder="96523, J1642, 0272-0372"
              onChange={(e: any) => {
                setCptCodes(e.value.map((item: any) => item.trim()));
                onChange(e.value.map((item: any) => item.trim()));
              }}
              separator=","
              onBlur={() => {
                handleOnBlurField({
                  onBlur,
                  field: "bundledCptCodes",
                  trigger,
                });
              }}
            />
            {getFormErrorMessage("bundledCptCodes", errors)}
          </>
        )}
      />
    </div>
  );
}
